import { render } from "./CashAndBanksSubledger.vue?vue&type=template&id=1b5b40a4"
import script from "./CashAndBanksSubledger.vue?vue&type=script&lang=js"
export * from "./CashAndBanksSubledger.vue?vue&type=script&lang=js"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__